import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

const initialState: number = 0;

const cartSlice = createSlice({
  name: "cartNum",
  initialState,
  reducers: {
    setCartTotal: (state, action) => {
      return action.payload;
    },
  },
  extraReducers: {
    // hydrated 用于获取服务端注入的state并选择更新
    [HYDRATE]: (state, action) => {
      return {
        ...action.payload.user,
      };
    },
  },
});

export const { setCartTotal } = cartSlice.actions;
export default cartSlice.reducer;
